import react, { useState } from 'react'

import { Alert, Box, InputLabel, TextField } from '@mui/material'
import { useGridApiContext, useGridRootProps } from '@mui/x-data-grid';

import ColorButton from '../Buttons/ColorButton';
import { api } from '../../services/api';
import toast from 'react-hot-toast';

const exportdata = async (email, apiRef, rootProps) => {
    
    const [reqURL,] = rootProps.getURL?.split("?")
    const searchParams = new URLSearchParams();

    //filter
    Object.entries(apiRef.current?.state?.filter?.filterModel?.customItems).forEach(([key, value]) => {
        value && searchParams.set([key.replace('__equals', '')], value)
    })

    //or
    if (apiRef.current?.state?.filter?.filterModel?.or)
        searchParams.set('or', 'or')

    const finalURL = `${reqURL}export/?${searchParams.toString()}`

    const res = await api.post(finalURL, {email: email})
    if (res.status === 200){
        toast.success(`Você receberá os dados no e-mail ${email} em breve. Aguarde alguns instantes.`)
    } else {
        toast.error(`Ocorreu um erro para exportar os dados: ${JSON.stringify(res.data)}`)
    }
    apiRef.close()
}

const Export = () => {

    const apiRef = useGridApiContext()
    const rootProps = useGridRootProps()

    const [email, setEmail] = useState('')

    return (
        <>
            <Box className='table-column-popover'>
                <Box sx={{ padding: '.5rem', display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
                    <InputLabel sx={{ whiteSpace: 'pre-line' }}>Digite um e-mail para receber os dados exportados</InputLabel>
                    <Alert>Você irá receber os dados por e-mail após um tempo e se tiver um e-mail configurado. Multiplas requisições não são possiveis na mesma empresa.</Alert>
                    <TextField
                        size='small'
                        label="Email"
                        value={email}
                        onChange={({ target }) => setEmail(target.value)}
                    />
                </Box>
                <ColorButton
                    reverse={false}
                    disabled={email.length === 0 || !email.includes('@') || !email.includes('.')}
                    onClick={() => {
                        exportdata(email, apiRef, rootProps)
                    }}>Exportar</ColorButton>
            </Box>
        </>
    )
}

export default Export